<template>
  <div class="app-main-content open-price">
    <div class="details-view" style="overflow: auto">
      <div style="margin-top: 5px">
        <el-button v-if="isEdit" v-permission="['button_OpenPrice_edit']" no="Cancel" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-if="isEdit" v-permission="['button_OpenPrice_edit']" type="success" no="Save" @click="save">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      </div>
      <div class="main-content">
        <div class="section" style="margin-top:5px;width:100%">
          <div>
            <span class="title">{{ $t('CargoMsg.Cargo_FilingBatchInfo') }}</span>
            <span style="margin-left:50px;font-size:15px;">{{ filingStateLabel }}</span>
          </div>
          <el-form :disabled="!isEdit" :inline="true" label-width="80px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_FilingBatchNo')">
              <el-input v-model="form.filingBatchNo" maxlength="20" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_FilingDate')">
              <el-date-picker
                v-model="form.filingDate"
                no="customsDate"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EffectiveDate')">
              <el-date-picker
                v-model="form.effectiveDate"
                no="customsDate"
                type="date"
                style="width:100%"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
              <el-input v-model="form.filingRemark" style="width:280px" maxlength="500" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section" style="width:100%;height:100%">
          <div>
            <span class="title">{{ $t('CargoMsg.Cargo_OpenPriceInfo') }}</span>
            <el-button v-show="isEdit" v-permission="['button_OpenPrice_edit']" type="primary" no="addPrice" style="margin-left:50px;" @click="toAddPrice">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button v-show="isEdit" v-permission="['button_OpenPrice_edit']" type="danger" no="deletePrice" @click="toDeletePrice">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <el-button v-show="isEdit" v-permission="['button_OpenPrice_edit']" type="primary" no="past6MonthPort" @click="toQueryPast6MonthsPort">{{ $t('CargoMsg.Cargo_Past6MonthPort') }}</el-button>
            <el-button v-show="isEdit" v-permission="['button_OpenPrice_edit']" type="primary" no="past1MonthPrice" @click="toQueryPast1MonthsPrice">{{ $t('CargoMsg.Cargo_Past1MonthPrice') }}</el-button>
            <el-upload
              no="uploadPrice"
              :action="URL.price.openPrice.uploadOpenPrice"
              :headers="{ sessionId }"
              :show-file-list="false"
              accept=".xls,.xlsx"
              :before-upload="beforeUpload"
              :on-success="uploadExcelSuccess"
              :on-error="uploadExcelError"
              :data="{ params: uploadParam }"
              :on-progress="uploadProcess"
              style="display:inline-block;margin-left:5px; margin-right:5px"
            >
              <el-button v-show="isEdit" v-permission="['button_OpenPrice_edit']" type="primary" no="upload">{{ $t('CargoMsg.Cargo_Upload') }}</el-button>
            </el-upload>
            <el-button v-show="isEdit" v-permission="['button_OpenPrice_edit']" type="primary" no="downImportTemplate" @click="downloadTemplate">{{ $t('CargoMsg.Cargo_DownImportTemplate') }}</el-button>
            <span style="margin-left:20px;font-size:14px;color:red;">{{ $t('CargoMsg.Cargo_DeclareNumLabel', [declareNumLabel]) }}</span>
          </div>
          <div class="grid-wrapper" style="padding-bottom:30px;height:100%">
            <cargo-ag-grid
              ref="tabPriceGrid"
              :grid-options="tabPrice.grid.gridOptions"
              :column-defs="dynamicColumnDefs"
              :grid-params.sync="tabPrice.grid.gridParams"
              :row-data="tabPrice.grid.rowData"
              :show-side-bar="false"
              :auto-fit-content="false"
              style="padding-bottom:50px;height:100%"
              @rowDataChanged="rowDataChanged"
              @gridReady="onCostGridReady"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { OpenPriceBatch } from '@/class/model/price/OpenPriceBatch'
import { OpenPrice } from '@/class/model/price/OpenPrice'
import { detailOpenPriceBatch, saveOpenPriceBatch, queryPast6MonthsPortList, queryPast1MonthsPriceList } from '@/api/price/openPrice'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { catchErrorTip } from '@/utils/commonUtil'
import { getUuid } from '@/utils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'

export default {
  name: 'OpenPriceDetail',
  components: { cargoAdvanceSelect },
  props: {
    source: { type: String, default: '' },
    companyCodes: { type: Array, default: () => [] }, // 公司代码
    lanes: { type: Array, default: () => [] }, // 航线
    eqSizes: { type: Array, default: () => [] }, // 尺码
    eqTypes: { type: Array, default: () => [] }, // 箱型
    cargoTypes: { type: Array, default: () => [] }, // 货种
    seaports: { type: Array, default: () => [] } // 海港
  },
  data() {
    return {
      URL,
      innerVisible: false,
      SystemConstants,
      loading: false,
      TYPE_NAMES,
      isEdit: false, // 是否 编辑
      isCopy: false, // 是否 复制
      form: new OpenPriceBatch().fillDefaultValue().getData(),
      originForm: {},
      openPriceList: [],
      abcs: [{ code: 'A' }, { code: 'B' }, { code: 'C' }], // ABC
      departureDays: SystemConstants.WEEKS, // 周班
      tabPrice: {
        grid: {
          uuidPrefixRule: 'addTabPrice__', // 临时新增的uuid规则
          deleteUuids: [],
          modifyUuids: [],
          selectedRow: null, // 当前选中行， 待处理
          gridApi: null,
          rowData: [],
          columnDefs: [],
          gridOptions: {},
          gridParams: {},
          groupColumns: {},
          groupRowNode: {}
        }
      },
      addCostEventFlag: false, // 新增事件标识
      gridReady: false
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    sessionId() {
      return this.$store.getters.token
    },
    uploadParam() {
      const params = {}
      params.branchId = this.$store.getters.currentOfficeId
      params.filingBatchNo = this.form.filingBatchNo || ''
      params.batchUuid = this.form.uuid || ''
      return JSON.stringify(params)
    },
    filingStateLabel() {
      return ColumnUtils.OpenPriceBatchStateLabelFun(this.form.filingState)
    },
    editing() {
      return this.isEdit
    },
    dynamicColumnDefs() {
      const result = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'), colId: 'serialNumber', field: 'serialNumber', initialWidth: 60, minWidth: 60,
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          editable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CompanyCode2'), colId: 'companyCode', field: 'companyCode', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: this.isZh ? 'chineseName' : 'englishName',
              customLabel: (item) => this.isZh && item.chineseName ? `[${item.code}]${item.chineseName}` : `[${item.code}]${item.englishName}`,
              showCustomLabelInOption: true,
              staticOptions: this.companyCodes,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code', 'chineseName', 'englishName']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Lane'), colId: 'lane', field: 'lane', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              const item = this.lanes.find(p => p.code === params.value)
              if (item) {
                return this.isZh && item.name ? `[${item.code}]${item.name}` : `[${item.code}]${item.nameEnglish}`
              }
            }
            return params.value
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: this.isZh ? 'name' : 'nameEnglish',
              customLabel: (item) => this.isZh && item.name ? `[${item.code}]${item.name}` : `[${item.code}]${item.nameEnglish}`,
              showCustomLabelInOption: true,
              staticOptions: this.lanes,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code', 'name', 'nameEnglish']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DepartureDay'), field: 'departureDay', colId: 'departureDay', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.WEEKS)
            }
            return ''
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: this.isZh ? 'chineseName' : 'englishName',
              staticOptions: this.departureDays,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code', 'chineseName', 'englishName']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: 'ABC', colId: 'abc', field: 'abc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: this.abcs,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_StartingPort'), colId: 'pol', field: 'pol', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              const item = this.seaports.find(p => p.code === params.value)
              if (item) {
                return CustomLableUtils.getPortLabel(item, 'auto_7')
              }
            }
            return params.value
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              customLabel: (item) => this.isZh && item.chineseName ? `[${item.code}]${item.chineseName}` : `[${item.code}]${item.englishName}`,
              showCustomLabelInOption: true,
              staticOptions: this.seaports,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code', 'chineseName', 'englishName']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_POD'), colId: 'pod', field: 'pod', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          valueFormatter: (params) => {
            if (params.value) {
              const item = this.seaports.find(p => p.code === params.value)
              if (item) {
                return CustomLableUtils.getPortLabel(item, 'auto_7')
              }
            }
            return params.value
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              customLabel: (item) => this.isZh && item.chineseName ? `[${item.code}]${item.chineseName}` : `[${item.code}]${item.englishName}`,
              showCustomLabelInOption: true,
              staticOptions: this.seaports,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code', 'chineseName', 'englishName']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainerSize'), colId: 'eqType', field: 'eqType', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              customLabel: (item) => this.isZh && item.localName ? `[${item.code}]${item.localName}` : `[${item.code}]${item.name}`,
              showCustomLabelInOption: true,
              staticOptions: this.eqTypes,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code', 'localName', 'name']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CargoType2'), colId: 'cargoType', field: 'cargoType', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              customLabel: (item) => this.isZh && item.chineseName ? `[${item.code}]${item.chineseName}` : `[${item.code}]${item.englishName}`,
              showCustomLabelInOption: true,
              staticOptions: this.cargoTypes,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code', 'chineseName', 'englishName']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EqSize'), colId: 'eqSize', field: 'eqSize', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: this.eqSizes,
              filterable: true,
              filterType: 'global',
              filterTagNames: ['code']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Cost2'), colId: 'cost', field: 'cost', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CostMin'), colId: 'costMin', field: 'costMin', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CostMax'), colId: 'costMax', field: 'costMax', initialWidth: 100, minWidth: 100,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Commission'), colId: 'commission', field: 'commission', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EqDeduct'), colId: 'eqDeduct', field: 'eqDeduct', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: 'BAF', colId: 'baf', field: 'baf', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: 'CAF', colId: 'caf', field: 'caf', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OtherSurcharge'), colId: 'otherSurcharge', field: 'otherSurcharge', initialWidth: 120, minWidth: 120,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: 'O.THC', colId: 'othc', field: 'othc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: 'D.THC', colId: 'dthc', field: 'dthc', initialWidth: 80, minWidth: 80,
          headerClass: 'ag-header-cell-right',
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'), colId: 'remarks', field: 'remarks', initialWidth: 150, minWidth: 150,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => params.data && this.editing,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]

      if (this.editing) {
        for (const data of result) {
          data.sortable = false
        }
      }
      return result
    },
    // 运价行数
    declareNumLabel() {
      if (this.tabPrice.grid.rowData && this.tabPrice.grid.rowData.length > 0) {
        return this.tabPrice.grid.rowData.length
      }
      return 0
    }
  },
  watch: {
    addCostEventFlag(newVal) {
      if (newVal) {
        this.addCostEventFlag = false
        return catchErrorTip(() => {
          return this.addPrice()
        })
      }
    }
  },
  async created() {
    await this.loadGridOptions()
  },
  methods: {
    onCostGridReady(params) {
      this.tabPrice.grid.gridApi = params.api
      this.gridReady = true
    },
    async loadGridOptions() {
      this.tabPrice.grid.gridOptions = {
        suppressRowClickSelection: true,
        suppressCopyRowsToClipboard: true,
        singleClickEdit: true,
        rowSelection: 'multiple',
        getRowStyle: (params) => {
          if (!params.data) {
            return {}
          }
          const item = params.data
          const rowStyle = {}
          if (Object.prototype.hasOwnProperty.call(item, 'error') && item.error) {
            Object.assign(rowStyle, { 'font-weight': 'bold', 'color': '#800000' })
          }
          return rowStyle
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onTabPriceCellFocused(event)
        },
        onSelectionChanged: (event) => {
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          if (!event.data) {
            return
          }
          this.onTabPriceRowSelected(event)
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridSelectEditor,
          CargoAgGridCommonTextareaEditor
        }
      }
    },
    onTabPriceCellFocused(event) {
      if (this.tabPrice.grid.gridApi && event.column) {
        this.tabPrice.grid.gridApi.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            if (event.data) {
              this.tabPrice.grid.selectedRow = node.data
            }
            this.tabPrice.grid.groupRowNode = node
          }
        })
      }
    },
    onTabPriceRowSelected(event) {
      if (event.node.isSelected()) {
        this.tabPrice.grid.selectedRow = event.node.data
      }
    },
    // 新增
    toAddPrice(callback = null) {
      // this.addCostEventFlag = true
      // if (callback) {
      //   this.$nextTick(() => {
      //     // 等待watch触发addPrice后执行回调
      //     callback && callback()
      //   })
      // }
      const addRow = () => {
        const obj = new OpenPrice().fillDefaultValue().getData()
        obj.serialNumber = this.getMaxSerialNumber() + 1
        obj.uuid = this.tabPrice.grid.uuidPrefixRule + getUuid()

        this.updateGridDataAndRestoreState(this.tabPrice.grid, obj)
        if (callback) {
          this.$nextTick(() => {
            // 等待watch触发addPrice后执行回调
            callback && callback()
          })
        }
      }
      // 检查 gridApi 是否已初始化，未初始化则等待后重试
      if (!this.tabPrice.grid.gridApi) {
        // 用 $nextTick 等待表格渲染，最多重试3次（防止无限等待）
        let retryCount = 0
        const retryAddRow = () => {
          retryCount++
          if (this.tabPrice.grid.gridApi || retryCount >= 3) {
            addRow() // 无论是否初始化，最终执行添加（兜底逻辑生效）
          } else {
            setTimeout(retryAddRow, 200) // 200ms 后重试
          }
        }
        this.$nextTick(retryAddRow)
      } else {
        addRow() // 已初始化，直接添加
      }
    },
    addPrice() {
      console.log('addPrice ~~')
      const obj = new OpenPrice().fillDefaultValue().getData()
      obj.serialNumber = this.getMaxSerialNumber() + 1
      obj.uuid = this.tabPrice.grid.uuidPrefixRule + getUuid()

      this.updateGridDataAndRestoreState(this.tabPrice.grid, obj)
    },
    // 更新表格数据
    updateGridDataAndRestoreState(grid, newObj) {
      if (grid.gridApi) {
        const updatedData = [newObj, ...this.tabPrice.grid.rowData]
        grid.gridApi.setRowData(updatedData)
        this.tabPrice.grid.rowData = updatedData
        this.$nextTick(() => {
          let newRowNode = null
          grid.gridApi.forEachNode((node, index) => {
            // 查找新增行节点
            if (node?.data?.uuid === newObj.uuid) {
              newRowNode = node
            }
          })

          if (newRowNode) {
            grid.gridApi.ensureIndexVisible(newRowNode.rowIndex, 'middle')
            grid.gridApi.setFocusedCell(newRowNode.rowIndex, 'serialNumber')
          }
        })
      }
    },
    // 删除
    toDeletePrice() {
      const rowData = this.tabPrice.grid.rowData
      const chooseRows = this.tabPrice.grid.gridApi.getSelectedRows()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      for (const item of chooseRows) {
        const index = rowData.indexOf(item)
        rowData.splice(index, 1)

        if (item.uuid && !item.uuid.startsWith(this.tabPrice.grid.uuidPrefixRule)) {
          this.tabPrice.grid.deleteUuids.push(item.uuid)
        }
        this.refreshSerialNumber(item.serialNumber) // 序号,递减
      }
    },
    // 刷新序号
    refreshSerialNumber(serialNumber) {
      const rowData = this.tabPrice.grid.rowData || []
      if (rowData.length === 1) { // 只有一条数据的时候，序号就是1
        for (const item of rowData) {
          item.serialNumber = 1
        }
      } else {
        for (const item of rowData) {
          if (item.serialNumber > serialNumber) {
            item.serialNumber = item.serialNumber - 1
          }
        }
      }
    },
    // 排序
    rowDataChanged(params) {
      if (!this.editing) {
        this.sortChanged(params, null, this.tabPrice.grid.rowData)
      }
    },
    // 获取最大序号
    getMaxSerialNumber() {
      let max = 0
      if (this.tabPrice.grid.rowData && this.tabPrice.grid.rowData.length > 0) {
        for (const c of this.tabPrice.grid.rowData) {
          if (c.serialNumber > max) {
            max = c.serialNumber
          }
        }
      }
      return max
    },
    async onCellChange(params) {
      const newParams = {
        rowIndex: params.node.rowIndex,
        colId: params.column.colId,
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        originalValue: params.oldValue
      }

      await this.gridItemEditEndHandler(newParams)
    },
    async gridItemEditEndHandler(params) {
      const item = params.data
      item.modifiedBy = this.$store.getters.userId
      item.dateModified = DateUtils.formatStandardDateTime(new Date())

      await this.gridDataFieldChanged(params)
    },
    async gridDataFieldChanged(params) {
      const item = params.data
      // 修改的只需要考虑数据库中存在的，新增的不用管
      if (!item.uuid.startsWith(this.tabPrice.grid.uuidPrefixRule)) {
        this.tabPrice.grid.modifyUuids.push(item.uuid)
      }
      switch (params.field) {
        case 'companyCode': {
          item.companyCode = params.value
          break
        }
        case 'lane': {
          item.lane = params.value
          break
        }
        case 'departureDay': {
          item.departureDay = params.value
          break
        }
        case 'abc': {
          item.abc = params.value
          break
        }
        case 'pol': {
          item.pol = params.value
          break
        }
        case 'pod': {
          item.pod = params.value
          break
        }
        case 'eqType': {
          item.eqType = params.value
          break
        }
        case 'cargoType': {
          item.cargoType = params.value
          break
        }
        case 'eqSize': {
          item.eqSize = params.value
          break
        }
        case 'cost': {
          item.cost = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'costMin': {
          item.costMin = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'costMax': {
          item.costMax = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'commission': {
          item.commission = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'eqDeduct': {
          item.eqDeduct = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'baf': {
          item.baf = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'caf': {
          item.caf = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'otherSurcharge': {
          item.otherSurcharge = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'othc': {
          item.othc = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'dthc': {
          item.dthc = isNaN(params.value) ? 0 : NumberUtils.ToFixed2(Number(params.value), 2)
          break
        }
        case 'remarks': {
          item.remarks = params.value
          break
        }
        default: {
          break
        }
      }
      // 刷新
      if (this.tabPrice.grid.gridApi) {
        this.tabPrice.grid.gridApi.refreshCells({ force: true })
        this.redrawRows(this.tabPrice.grid.gridApi, this.$refs.tabPriceGrid, params.rowIndex, params.colId)
      }
    },
    // 重新渲染行数据
    redrawRows(gridApi, gridRef, excludingRowIndex, excludingColId) {
      const editingRow = gridRef.$el.querySelector('.ag-row-inline-editing')
      if (editingRow) {
        const editingCell = editingRow.querySelector('.ag-cell-inline-editing')
        if (editingCell) {
          const rowIndex = Number(editingRow.getAttribute('row-index'))
          const colId = editingCell.getAttribute('col-id')
          if (rowIndex !== excludingRowIndex || colId !== excludingColId) {
            gridApi.redrawRows()
            gridApi.startEditingCell({ rowIndex, colKey: colId })
            return
          }
        }
      }
      gridApi.redrawRows()
    },
    // 初始化时，uuid存在时查询
    async init() {
      if (!this.form.uuid) {

      } else {
        this.detail()
      }
    },
    // 获取详情
    detail() {
      this.loading = getLoading4Cxt()
      detailOpenPriceBatch({ batchUuid: this.form.uuid }).then(res => {
        // 复制
        if (this.isCopy && res.data) {
          // 重置
          res.data.uuid = ''
          res.data.filingBatchNo = '' // 备案批次号
          res.data.filingState = SystemConstants.OPEN_PRICE_BATCH_DRAFT.code
          //
          res.data.filingRemark = ''
          res.data.filingDate = null
          res.data.effectiveDate = null
          res.data.submitDate = null
          res.data.submitBy = 0
          res.data.rpaState = SystemConstants.OPEN_PRICE_RPA_DEFAULT.code
          res.data.rpaStateDate = null
          res.data.rpaStateBy = 0
          res.data.declareNum = 0
          res.data.finalNum = 0
          res.data.declareFinal = ''
          res.data.fileTotalNum = 0
          res.data.recordNum = 0
          res.data.passNum = 0
          res.data.filetotalRecordPass = ''
          res.data.uploadFileId = ''
          res.data.uploadFileName = ''
          res.data.uploadFileSize = 0
          res.data.uploadFileType = ''
          res.data.uploadFileError = ''
          res.data.importResultFileId = ''
          res.data.importResultFileName = ''
          res.data.importResultFileSize = 0
          res.data.importResultFileType = ''
          res.data.importResultFileError = ''
          res.data.exportFileId = ''
          if (res.data.openPriceList) {
            for (const item of res.data.openPriceList) {
              item.uuid = ''
              item.batchUuid = ''
              item.filingBatchNo = ''
            }
          }
        }
        this.originForm = res.data
        this.setForm(this.originForm)
      }).finally(() => {
        this.loading.close()
      })
    },
    setForm(form) {
      this.form = form
      this.tabPrice.grid.rowData = this.form.openPriceList || []
      this.tabPrice.grid.modifyUuids = []
      this.tabPrice.grid.deleteUuids = []
    },
    // 取消
    cancel() {
      this.$emit('cancel', this.source)
    },
    // 保存
    save() {
      if (!this.form.uuid) {
        this.form.branchId = this.$store.getters.currentOfficeId
      }
      // 备案批次
      this.form.filingBatchNo = this.form.filingBatchNo.trim()
      if (!this.form.filingBatchNo) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FilingBatchNo') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.form.filingDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_FilingDate') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.form.effectiveDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EffectiveDate') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (this.tabPrice.grid.rowData && this.tabPrice.grid.rowData.length > 0) {
        for (const item of this.tabPrice.grid.rowData) {
          // 临时新增的uuid
          if (item.uuid.startsWith(this.tabPrice.grid.uuidPrefixRule)) {
            item.uuid = ''
          }
          // 标记修改
          if (!item.uuid || (item.uuid && this.tabPrice.grid.modifyUuids.includes(item.uuid))) {
            item.changed = true
          }
          // 不能为空
          let emptyMsg = ''
          // 校验项
          if (!item.companyCode) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_CompanyCode2')
          }
          if (!item.lane) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_Lane')
          }
          if (!item.pol) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_StartingPort')
          }
          if (!item.pod) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_POD')
          }
          if (!item.eqType) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_ContainerSize')
          }
          if (!item.cargoType) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_CargoType2')
          }
          if (!item.eqSize) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_EqSize')
          }
          if (!item.cost) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_Cost2')
          }
          if (!item.costMin) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_CostMin')
          }
          if (!item.costMax) {
            emptyMsg += (emptyMsg ? '、' : '') + this.$t('CargoMsg.Cargo_CostMax')
          }
          if (emptyMsg) {
            this.$message.warning('【' + item.serialNumber + '】【' + emptyMsg + '】' + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            return
          }
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_OpenPriceInfo') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }

      this.loading = getLoading4Cxt()
      this.form.openPriceList = this.tabPrice.grid.rowData
      this.form.delPriceUuids = this.tabPrice.grid.deleteUuids
      this.form.currentOfficeId = this.$store.getters.currentOfficeId
      this.form.oplogList = this.form.oplogList || []
      this.form.finalPriceList = this.form.finalPriceList || []
      saveOpenPriceBatch(this.form).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('back', this.source)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 下载模板
    downloadTemplate() {
      ExportUtils.downloadTemplateFile('OpenPriceTemplate.xls')
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('Information.TheOnlyBeXlsFormat'))
      }
      if ((Math.round(file.size * 100 / (1024 * 1024)) / 100) > 5) {
        this.$message.warning(this.$t('CargoMsg.FileBeLargerThan5MB'))
        return false
      }
      return extension || extension2
    },
    uploadExcelSuccess(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(data) {
      if (data.errMessage) {
        this.$confirm(data.errMessage, this.$t('Message.Error2'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
          showCancelButton: false,
          type: 'error'
        }).then(() => {
          return
        }).catch(() => {})
      } else {
        // 移出
        if (this.tabPrice.grid.rowData && this.tabPrice.grid.rowData.length > 0) {
          for (const item of this.tabPrice.grid.rowData) {
            if (item.uuid && !this.tabPrice.grid.deleteUuids.includes(item.uuid) && !item.uuid.startsWith(this.tabPrice.grid.uuidPrefixRule)) {
              this.tabPrice.grid.deleteUuids.push(item.uuid)
            }
          }
        }
        if (data.priceList && data.priceList.length > 0) {
          this.tabPrice.grid.rowData = data.priceList
        }
        if (data.filingDate) {
          this.form.filingDate = data.filingDate
        }
        if (data.effectiveDate) {
          this.form.effectiveDate = data.effectiveDate
        }
      }
    },
    uploadExcelError(err) {
      this.loading.close()
    },
    uploadProcess() {
      this.loading = getLoading('open-price')
    },
    sortChanged(params, columnDefs, rowData) {
      let serialNumber = 0
      const nodes = params.api.rowModel.rowsToDisplay
      nodes.forEach(node => {
        const row = rowData.filter(row => {
          return (row.uuid || row.id) === (node.data.uuid || node.data.id)
        })[0]
        row.serialNumber = ++serialNumber
      })
      params.api.refreshCells({ force: true })
    },
    toQueryPast6MonthsPort() {
      this.loading = getLoading4Cxt()
      this.form.openPriceList = this.tabPrice.grid.rowData
      this.form.currentOfficeId = this.$store.getters.currentOfficeId
      this.form.delPriceUuids = []
      this.form.oplogList = []
      this.form.finalPriceList = []
      queryPast6MonthsPortList(this.form).then(res => {
        if (res && res.data && res.data.length > 0) {
          for (const item of res.data) {
            if (!item.uuid) {
              item.uuid = this.tabPrice.grid.uuidPrefixRule + getUuid()
            }
          }
          this.tabPrice.grid.rowData = res.data
          this.$message.success(this.$t('CargoMsg.Cargo_QuerySuccess'))
        } else {
          this.$message.info(this.$t('SeaExport.promptNoData'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    toQueryPast1MonthsPrice() {
      const chooseRows = this.tabPrice.grid.gridApi.getSelectedRows()
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectAtLeastOneRecord'))
        return
      }
      this.loading = getLoading4Cxt()
      const params = {}
      params.openPriceList = chooseRows
      params.currentOfficeId = this.$store.getters.currentOfficeId
      params.delPriceUuids = []
      params.oplogList = []
      params.finalPriceList = []
      queryPast1MonthsPriceList(params).then(res => {
        if (res && res.data && res.data.length > 0) {
          const priceMap = new Map()
          for (const price of res.data) {
            priceMap.set(price.uuid, price)
          }
          for (const item of chooseRows) {
            const price = priceMap.get(item.uuid)
            if (price) {
              item.cost = price.cost || 0
              item.costMin = price.costMin || 0
              item.costMax = price.costMax || 0
              item.changed = true
            }
          }
          this.tabPrice.grid.gridApi.setRowData(this.tabPrice.grid.rowData)
          this.$message.success(this.$t('CargoMsg.Cargo_QuerySuccess'))
        } else {
          this.$message.info(this.$t('SeaExport.promptNoData'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    setInitialData(rowData, index) {
      if (!rowData) {
        return
      }
      if (!Array.isArray(this.tabPrice.grid.rowData) || this.tabPrice.grid.rowData.length === 0) {
        console.log('行数据为空，重新添加行后赋值')
        // 重新添加行并赋值
        this.toAddPrice(() => this.setInitialData(rowData, index))
        return
      }
      if (this.tabPrice.grid.rowData && this.tabPrice.grid.rowData.length > 0) {
        const newRow = this.tabPrice.grid.rowData[0]
        // 直接使用传递过来的对象字段赋值
        newRow.companyCode = rowData.companyCode
        newRow.lane = rowData.lineCode
        newRow.departureDay = rowData.weekDay
        newRow.pol = rowData.pol
        newRow.pod = rowData.pod
        newRow.eqType = rowData.eqType
        newRow.eqSize = rowData.eqSize
        newRow.cargoType = rowData.cargoType
        // 刷新表格
        // this.tabPrice.grid.api.refreshCells()
        if (this.tabPrice.grid.gridApi) {
          this.tabPrice.grid.gridApi.refreshCells({
            rowNodes: [this.tabPrice.grid.gridApi.getDisplayedRowAtIndex(0)], // 只刷新第一行
            forceRefresh: true // 强制刷新
          })
        }
      }
    },
    waitForGridInit() {
      return new Promise((resolve) => {
        // 如果已初始化，直接resolve
        if (this.gridReady) {
          resolve()
          return
        }
        // 未初始化则轮询检查（最多等待3秒，避免无限等待）
        const checkInterval = setInterval(() => {
          if (this.gridReady) {
            clearInterval(checkInterval)
            resolve()
          }
        }, 100) // 每100ms检查一次

        // 超时保护
        setTimeout(() => {
          clearInterval(checkInterval)
          resolve() // 超时后仍resolve，避免阻塞
        }, 3000)
      })
    },
    clearTableRows() {
      // 1. 清空rowData数组
      this.tabPrice.grid.rowData = []

      console.log('this.tabPrice.grid.gridApi', this.tabPrice.grid.gridApi)
      // 2. 确保gridApi初始化后再刷新表格
      return this.waitForGridInit().then(() => {
        if (this.tabPrice.grid.gridApi) {
          this.tabPrice.grid.gridApi.setRowData([])
          this.tabPrice.grid.gridApi.refreshCells({ force: true })
        }
      })
    }
  }
}
</script>

